import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { getMessage } from "../../utils/getMessage";
import { getImage } from "../../utils/getImage";
export default function AlertDialog({
  show,
  msgAlert,
  captcha,
  msg,
  setShowAlert,
  cliente,
  icon,
  img,
  imgClassName,
}) {
  const handleClose = () => {
    setShowAlert(false);
  };
  // console.log('mensaje',msg)
  // console.log('captcha',captcha)
  return (
    <Dialog
      className="dialog-container"
      open={show}
      onClose={handleClose}
      BackdropProps={{ onClick: handleClose }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className="dialog" id="alert-dialog-title">
        <div className="content-dialog banner-required">
          {icon && (
            <div className="img-dialog">
              {img && <img src={img} className={imgClassName} width={40} alt="icono" />}
            </div>
          )}
          {/* {process.env.REACT_APP_NAME_FORM === "Oncosalud" && (
            <img
              src={
                cliente === "ONCOSALUD" || cliente === ""
                  ? getImage(3)
                  : getImage(4)
              }
              width={40}
              alt="icono"
            />
          )} */}
          {msg && <span>{getMessage(5)}</span>}
          {captcha && <span>{getMessage(12)}</span>}
        </div>
      </DialogTitle>
      <DialogActions>
        <Button className="material-button" variant="outlined" onClick={handleClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
